module.exports = __webpack_public_path__ + "static/media/solutions-icon-1.bbbf95f4.svg";